export const isDocumentsOnlyActive = (
	flag: boolean | undefined,
	hasDocumentsFeature: boolean,
): boolean => Boolean(flag) && hasDocumentsFeature;
